(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/game-wager/assets/javascripts/generate-joker.js') >= 0) return;  svs.modules.push('/components/numbergames/game-wager/assets/javascripts/generate-joker.js');

'use strict';

const _svs$numbergames = svs.numbergames,
  productMapping = _svs$numbergames.productMapping,
  _svs$numbergames$rule = _svs$numbergames.rules,
  getRules = _svs$numbergames$rule.getRules,
  jokerRules = _svs$numbergames$rule.joker,
  gameWager = _svs$numbergames.gameWager;

function getJokerOptions(rules, options) {
  const getPrice = () => {
    var _rules$defaultJokerPr;
    if (jokerRules.getJokerPrices().includes(options === null || options === void 0 ? void 0 : options.price)) return options.price;
    return (_rules$defaultJokerPr = rules.defaultJokerPrice) !== null && _rules$defaultJokerPr !== void 0 ? _rules$defaultJokerPr : 0;
  };
  const getRow = () => {
    if (jokerRules.isValidRow(options === null || options === void 0 ? void 0 : options.numbers)) {
      return Array.from(options === null || options === void 0 ? void 0 : options.numbers).map(n => {
        var _n$number;
        return {
          number: Number((_n$number = n.number) !== null && _n$number !== void 0 ? _n$number : n),
          manual: Boolean(n.manual)
        };
      });
    }
    return jokerRules.getHuxfluxedRow();
  };
  return {
    getPrice,
    getRow
  };
}

function generateJoker(product) {
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (!productMapping.hasJoker(product) || !options) return;
  const rules = getRules(product, options.ruleOptions);
  const jokerOptions = gameWager.getJokerOptions(rules, options);
  return {
    productId: productMapping.CONSTANTS.JOKER,
    price: jokerOptions.getPrice(),
    numbers: jokerOptions.getRow()
  };
}
Object.assign(svs.numbergames.gameWager, {
  getJokerOptions,
  generateJoker
});

 })(window);